import { CalendarClock, Flame, History, Inbox, ListChecks } from 'lucide-react'

import { ROLES } from '@/constants/roles'

// `action` is the Prepacks product action a tab needs beyond view access.
export const AUTOMATION_TABS = [
  { to: '/dashboard/prepacks/automations/boosts', label: 'Boosts', icon: Flame, action: 'operate' },
  { to: '/dashboard/prepacks/automations/schedules', label: 'Schedules', icon: CalendarClock },
  // The packs no live schedule made (#1080): every Prepacks role, like Schedules.
  { to: '/dashboard/prepacks/automations/unscheduled', label: 'Unscheduled packs', icon: Inbox },
  { to: '/dashboard/prepacks/automations/master-list', label: 'Master list', icon: ListChecks, role: ROLES.SUPER_ADMIN },
  { to: '/dashboard/prepacks/automations/history', label: 'History', icon: History, action: 'operate' },
]
